<div class="customer-banner" *ngIf="isLoggedToClient() || !isHomeComponent()">
    <span *ngIf="!isHomeComponent()">
        <ng-hbm-bdi-btn class="transparent" (click)="goToHomePage()" [label]="'popins.banner.backToHome' | translate"></ng-hbm-bdi-btn>
    </span>
    <div class="customer-banner__text big" *ngIf="isLoggedToClient()">
        <span>{{ ('popins.banner.accountOf' | translate) + getCustomerName() }}<small>{{ " (" + getMagentoId() + ")" }}</small></span>
        <div class="customer-banner__buttons">
            <ng-hbm-bdi-btn *ngIf="!isHomeComponent()" class="transparent smaller" (click)="openProjects()" [label]="'popins.banner.projects' | translate"></ng-hbm-bdi-btn>
            <ng-hbm-bdi-btn class="primary smaller" (click)="logout()" [label]="'popins.banner.logout' | translate" ></ng-hbm-bdi-btn>
        </div>
    </div>
</div>

